import React, { useState, useEffect } from 'react';
import { Timeline, Tag, Empty, Spin, Typography } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import axiosInstance from '../../../variables/api/axiosInstance';
import dayjs from 'dayjs';

const ACTION_CONFIGS = {
  AUTH_LOGIN:           { label: 'Connexion',           color: 'green',    icon: '🔐' },
  AUTH_LOGOUT:          { label: 'Déconnexion',          color: 'default',  icon: '🚪' },
  AUTH_LOGIN_FAILED:    { label: 'Échec connexion',      color: 'red',      icon: '⛔' },
  AUTH_PASSWORD_CHANGE: { label: 'Changement mdp',       color: 'orange',   icon: '🔑' },
  AUTH_PASSWORD_RESET:  { label: 'Réinitialisation mdp', color: 'orange',   icon: '🔓' },
  CONTRACT_CREATE:      { label: 'Contrat créé',         color: 'blue',     icon: '📄' },
  CONTRACT_UPDATE:      { label: 'Contrat modifié',      color: 'cyan',     icon: '✏️' },
  CONTRACT_DELETE:      { label: 'Contrat supprimé',     color: 'red',      icon: '🗑️' },
  CONTRACT_PRINT:       { label: 'Impression',           color: 'purple',   icon: '🖨️' },
  CONTRACT_AVENANT:     { label: 'Avenant',              color: 'geekblue', icon: '📋' },
  MIGRATION_IMPORT:     { label: 'Import migration',     color: 'gold',     icon: '📥' },
  USER_CREATE:          { label: 'Utilisateur créé',     color: 'blue',     icon: '👤' },
  USER_UPDATE:          { label: 'Utilisateur modifié',  color: 'cyan',     icon: '✏️' },
  USER_DELETE:          { label: 'Utilisateur supprimé', color: 'red',      icon: '🗑️' },
  USER_ACTIVATE:        { label: 'Activation',           color: 'green',    icon: '✅' },
  USER_DEACTIVATE:      { label: 'Désactivation',        color: 'orange',   icon: '⏸️' },
  PARAMS_CREATE:        { label: 'Paramètre créé',       color: 'volcano',  icon: '⚙️' },
  PARAMS_UPDATE:        { label: 'Paramètre modifié',    color: 'volcano',  icon: '⚙️' },
  PARAMS_DELETE:        { label: 'Paramètre supprimé',   color: 'red',      icon: '⚙️' },
  OTHER:                { label: 'Autre',                color: 'default',  icon: '•' },
};

const ActiviteUtilisateur = ({ utilisateurCodeId }) => {
  const [logs,    setLogs]    = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!utilisateurCodeId) return;
    setLoading(true);
    axiosInstance
      .get(`/api/activity-logs/user/${utilisateurCodeId}?limit=50`)
      .then(({ data }) => setLogs(data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [utilisateurCodeId]);

  return (
    <div style={{ padding: '8px 24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <Typography.Title level={5} style={{ margin: 0, color: '#242166' }}>
          Historique d'activité
        </Typography.Title>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          50 dernières actions
        </Typography.Text>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
      ) : logs.length === 0 ? (
        <Empty description="Aucune activité enregistrée" />
      ) : (
        <Timeline
          items={logs.map(log => {
            const cfg = ACTION_CONFIGS[log.actionType] || ACTION_CONFIGS.OTHER;
            return {
              color: log.success ? (cfg.color === 'default' ? 'gray' : cfg.color) : 'red',
              dot: log.success
                ? <span style={{ fontSize: 15, lineHeight: 1 }}>{cfg.icon}</span>
                : <CloseCircleFilled style={{ color: '#ff4d4f', fontSize: 14 }} />,
              children: (
                <div style={{ paddingBottom: 6 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 2 }}>
                    <Tag color={cfg.color} style={{ borderRadius: 20, fontWeight: 500, margin: 0 }}>
                      {cfg.label}
                    </Tag>
                    {!log.success && (
                      <Tag color="red" style={{ borderRadius: 20, margin: 0 }}>Échec</Tag>
                    )}
                    <span style={{ color: '#aaa', fontSize: 12 }}>
                      {dayjs(log.createdAt).format('DD/MM/YYYY à HH:mm:ss')}
                    </span>
                  </div>
                  {log.description && (
                    <div style={{ color: '#555', fontSize: 13, marginBottom: 2 }}>
                      {log.description}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 16 }}>
                    {log.entityType && (
                      <span style={{ fontSize: 11, color: '#888' }}>
                        {log.entityType}
                        {log.entityCodeId ? ` — ${log.entityCodeId}` : ''}
                      </span>
                    )}
                    {log.ipAddress && (
                      <span style={{ fontSize: 11, color: '#bbb', fontFamily: 'monospace' }}>
                        IP : {log.ipAddress}
                      </span>
                    )}
                  </div>
                </div>
              ),
            };
          })}
        />
      )}
    </div>
  );
};

export default ActiviteUtilisateur;
